<template>
  <div class="edit_infomation">
    <el-card>
      <el-form ref="editFormRef" :model="editForm" label-width="120px">
        <el-form-item label="标题：">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="关联企业名称：">
          <el-input v-model="editForm.enterpriseName"></el-input>
        </el-form-item>
        <el-form-item label="关联投资机构：">
          <el-input v-model="editForm.investmentOrganization"></el-input>
        </el-form-item>
        <el-form-item label="轮次：">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="投资金额(万)：">
          <el-input v-model="editForm.investmentAmount"></el-input>
        </el-form-item>
        <el-form-item label="资讯内容：" class="editorbar">
          <Editorbar v-model="editForm.informationContent" :isClear="isClear" />
        </el-form-item>
        <el-form-item label="资讯图集：" class="upload_img">
          <upload-images
            :fileList.sync="imageUrlList"
            @updateImgTwo="updateImgTwo"
            @updateImgShowTwo="updateImgShowTwo"
            @removeImg="emitImgRemove"
          />
        </el-form-item>
        <el-form-item label="来源链接：" class="form_foot">
          <a :href="editForm.sourceUrl" target="_blank">{{ editForm.sourceUrl }}</a>
        </el-form-item>
        <el-form-item label="来源：" class="form_foot">
          <span>{{ editForm.source }}</span>
        </el-form-item>
        <el-form-item label="添加时间：" class="form_foot">
          <span>{{ editForm.createTime }}</span>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="foot">
      <el-button type="primary" @click="addClue">添加为线索</el-button>
      <el-button type="primary" @click="saveBtn">保存</el-button>
      <el-button plain @click="returnPage">返回上级</el-button>
    </div>
  </div>
</template>

<script>
import { updateInvestment, getInvestmentEventById, saveClue } from '@/api/businessCenter.js'
import UploadImages from '@/components/UploadImages.vue'

const addFormObj = Object.freeze({
  accomplishProject: '', //已完成项目id
  city: '', //城市
  clueCode: '', //线索编号
  clueMessenger: '测试01', //线索信息员
  companyProfiles: '', //企业介绍
  createName: null, //创建人名字
  createTime: '', //创建时间
  customerManager: '', //客户经理
  englishName: null, //商务经理
  enterpriseAbbreviation: '测试01', //企业简称
  enterpriseName: '测试01', //企业全称
  enterpriseSites: '', //企业官网
  establishTime: '', //成立时间
  logo: '', //企业logo
  nation: '中国', //国家
  prepare: '1', //会前准备(1：会前准备；2：已通知；3：已有链接)
  prepareUrl: null, //准备地址
  priority: '3', //优先级别（0->低;1->中;2->高;3->更高;）
  province: '北京', //省份
  schedule: '0', //进度0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
  sourceWay: '1', //来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
  statisticsTime: null, //线索各种数据新增时间
  updateName: null, //修改人名字
  updateTime: null, //修改时间
  investmentEventId: 0 //选中的id
})
const editFormobj = Object.freeze({
  createTime: '', //添加时间
  enterpriseName: '', //关联企业名称
  id: 0,
  informationContent: '', //咨询内容
  informationImages: '', //资讯图集
  informationImagesList: [], //资讯图集(集合)
  investmentAmount: 0, //投资金额（万）
  investmentOrganization: '', //投资机构
  isCreate: true, //是否已添加到线索
  rank: '', //轮次
  source: '', //来源
  sourceUrl: '', //来源链接
  title: '', //标题
  updateName: '' //修改人员
})

export default {
  name: 'editInfomation',
  components: {
    Editorbar: () => import('@/components/Editorbar.vue'),
    UploadImages
  },
  data() {
    return {
      imageList: [],
      imageUrlList: [],
      id: 0,
      editForm: { ...editFormobj }, //编辑填写的数据
      addForm: [{ ...addFormObj }], //调新增接口传的参数
      isClear: false, //富文本编辑组件属性
      showImage: true //临时
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getInfo()
  },
  methods: {
    //多个图片上传移除
    emitImgRemove(val) {
      for (var i = 0; i < this.imageUrlList.length; i++) {
        if (this.imageUrlList[i].uid === val.uid) {
          this.editForm.informationImagesList.splice(i, 1)
        }
      }
      this.imageUrlList = this.imageUrlList.filter((item) => {
        return item !== val
      })
      this.editForm.informationImagesList = this.imageUrlList.filter((item) => {
        return item !== val
      })
      this.editForm.informationImagesList = this.editForm.informationImagesList.map((el) => {
        return el.url
      })
    },
    //多个图片上传
    updateImgTwo(val) {
      this.imageList = val
    },
    //多个图片上传显示
    updateImgShowTwo(val) {
      this.imageUrlList = val
    },
    //根据id查信息
    async getInfo() {
      const { data: res } = await getInvestmentEventById({ id: this.id })
      if (res.resultCode === 200) {
        this.editForm = res.data
        if (res.data.informationImagesList) {
          res.data.informationImagesList.forEach((item) => {
            this.imageUrlList.push({
              url: item,
              name: item
            })
          })
        }
      } else {
        return this.$message.error('查询失败！')
      }
    },
    //添加线索按钮
    async addClue() {
      this.addForm[0].clueMessenger = this.editForm.updateName
      this.addForm[0].enterpriseAbbreviation = this.editForm.enterpriseName
      this.addForm[0].enterpriseName = this.editForm.enterpriseName
      this.addForm[0].investmentEventId = this.editForm.id
      this.saveBtn()
      const { data: res } = await saveClue(this.addForm)
      if (res.resultCode === 200) {
        this.$message.success('添加成功！')
        this.addForm = { ...addFormObj }
        this.$router.push({
          path: '/businessCenter/investmentEvent'
        })
      } else {
        this.$message.error('添加失败！')
      }
    },
    //保存按钮
    async saveBtn() {
      let array = []
      this.imageUrlList.forEach((el) => {
        array.push(el.url)
      })
      this.editForm.informationImagesList = array
      //确认数据正常后调接口
      const { data: res } = await updateInvestment(this.editForm)
      if (res.resultCode === 200) {
        this.editForm = { ...editFormobj }
        this.$message.success('编辑成功！')
        this.$router.go(-1)
      } else {
        this.$message.error('编辑保存失败！')
      }
    },
    //返回按钮
    returnPage() {
      this.$router.push({
        path: '/businessCenter/investmentEvent'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit_infomation {
  position: relative;
}
::v-deep .el-form-item .el-input__inner {
  width: 600px;
}
.el-card {
  height: 80vh;
  overflow: scroll;
}
.editorbar {
  width: 600px;
}
.upload_img {
  margin-bottom: 0;
}
.form_foot {
  margin-bottom: 0;
  span {
    color: #999;
  }
  ::v-deep .el-form-item__label {
    color: #999;
  }
}

::v-deep .el-form-item .el-form-item__content {
  display: flex;
  flex-flow: row nowrap;
  .imgs img {
    width: 100px;
    height: 100px;
    margin-right: 5px;
  }
}
.foot {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  padding: 16px;
  // border-top: #999 1px solid;
  background: #fff;
  box-shadow: 0px -2px 4px 0px #00000014;
}

/*去除a标签下划线*/
a {
  color: #4d70fa;
  text-decoration: none;
}
/*去除未被访问的a标签的下划线*/
a:link {
  text-decoration: none;
}
/*去除已经被访问过的a标签的下划线*/
a:visited {
  text-decoration: none;
}
/*去除鼠标悬停时的a标签的下划线*/
a:hover {
  text-decoration: none;
}
/*去除正在点击的a标签的下划线（鼠标按下，尚未松开）*/
a:active {
  text-decoration: none;
}
/*去除获得焦点的a标签的下划线（被鼠标点击过）*/
a:focus {
  text-decoration: none;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .el-card {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 14px !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .el-card {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 164px !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .el-card {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 296px !important;
  }
}

// 1280x1024 (1280x863)
@media (max-width: 1282px) and (max-height: 864px) {
  .el-card {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 40px !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .el-card {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 106px !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 262px !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 296px !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 342px !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 464px !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 198px !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 294px !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .el-card {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .foot {
    bottom: 462px !important;
  }
}
</style>
